import { render, staticRenderFns } from "./AccessDeniedError.vue?vue&type=template&id=6ef4f022&scoped=true&"
import script from "./AccessDeniedError.vue?vue&type=script&lang=js&"
export * from "./AccessDeniedError.vue?vue&type=script&lang=js&"
import style0 from "./AccessDeniedError.vue?vue&type=style&index=0&id=6ef4f022&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef4f022",
  null
  
)

export default component.exports